import GraphMissingImages from '../../../components/vehicle/graph_missing_images'
import GraphMissingImagesStore from '../../../components/vehicle/graph_missing_images/context/context'

const GraphMissingImagesPage = () => {
  return (
    <GraphMissingImagesStore>
      <GraphMissingImages />
    </GraphMissingImagesStore>
  )
}

export default GraphMissingImagesPage
